module.exports = __webpack_public_path__ + "fonts/Cabin-600-latin-ext8.6b71d0a.woff2";